export const DATASET_STREAM_MAX_RETRIES = 3;

export class CustomError<T = unknown> extends Error {
  code: number;
  message: string;
  details?: T;

  constructor(message: string, code: number, details?: T) {
    super(message);
    this.code = code;
    this.message = message;
    this.details = details;
  }
}

export class UnauthorizedStreamError extends Error {
  constructor() {
    super("Unauthorized");
    this.name = "UnauthorizedStreamError";
  }
}
